export function formatOrganizationLabel(org) {
  if (!org) return ''
  const name = org.organization_name || org.name || `Shop ${org.id}`
  return `${name} (Shop Id ${org.id})`
}
